import { ActionReducerMap } from '@ngrx/store';
import { accessRequestFetchReducer } from './access-request-fetch.reducer';
import { AccessRequestState } from '../access-request.state';

export const customReducers: ActionReducerMap<AccessRequestState> = {
    fetch: accessRequestFetchReducer,
};